import { useCallback } from 'react';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

import { FILE_VALIDATION } from '@ecp/common/src/const/imageFile';

const useFileUploader = (props) => {
  const { dragdrop, multiple, maxCount, maxSize, maxTotalSize, extension, disabled, onChange } = props;

  const validate = useCallback(
    (e, fileList) => {
      const errors = [];
      if (multiple && maxCount && fileList.length > maxCount) {
        errors.push(FILE_VALIDATION.EXCEED_MAXIMUM_FILE_COUNT);
      }
      const reg = new RegExp(`(.*?).(${extension.join('|')})$`, 'gi');
      if (fileList.some(({ name }) => !name || name.match(reg) === null || !reg.test(name))) {
        errors.push(FILE_VALIDATION.INVALID_FILE_EXTENSION);
      }
      if (fileList.some(({ size }) => size > maxSize)) {
        errors.push(FILE_VALIDATION.EXCEED_MAXIMUM_FILE_SIZE);
      }
      if (fileList.reduce((total, { size }) => total + size, 0) > (maxTotalSize || maxSize * (maxCount || 1))) {
        errors.push(FILE_VALIDATION.EXCEED_MAXIMUM_TOTAL_SIZE);
      }
      const invalidFileList = errors.length ? [...fileList] : [];
      onChange?.(e, errors.length ? [] : fileList, { errors, fileList: invalidFileList });
    },
    [extension, multiple, maxCount, maxSize, maxTotalSize, onChange]
  );

  const handleChange = useCallback(
    (e) => {
      e.stopPropagation();
      validate(e, [...e.target.files]);
    },
    [validate]
  );

  const [{ isActive }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        dragdrop && validate(null, item.files);
      },
      collect: (monitor) => {
        return {
          isActive: monitor.isOver() && monitor.canDrop(),
        };
      },
    }),
    [dragdrop, validate]
  );

  const getDropzoneProps = useCallback(() => ({ active: isActive ? 'active' : '' }), [isActive]);

  const getInputProps = useCallback(
    () => ({
      type: 'file',
      multiple,
      disabled,
      onChange: handleChange,
      accept: `.${extension.join(',.')}`,
    }),
    [multiple, disabled, extension, handleChange]
  );

  return {
    drop,
    getDropzoneProps,
    getInputProps,
  };
};

export default useFileUploader;
